export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
export const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_KEY;
export const LOGO_URL = "https://eurospectooling.com/wp-content/uploads/2024/03/logo-e1711467462820.png";
export const INACTIVITY_MS = 10 * 60 * 1000;
export const APP_SLOGAN = "Log it. Approve it. Export it.";
export const DEV_NAME = "Dhyey Chokshi (Developer)";
export const DEV_EMAIL = "dchokshi@eurospectooling.com";
export const HIGHER_ROLES = ["supervisor", "finance", "admin"];
